module.exports = __webpack_public_path__ + "media/Video 52.300ef66b.mp4";